import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectState = (state: StoreSchema) => state.users.state
